<template>
  <div class="wrapper">
    <div style="margin-bottom:20px;">
      <el-button v-auth="'sys:whiteList:add'"  @click="handleEdit('',0)" type="primary" icon="el-icon-plus">{{$t('common.addNew')}}</el-button>
      <el-button v-auth="'sys:whiteList:sync'"  type="primary" icon="el-icon-s-promotion" @click="synchronize()">{{$t('whiteList.synchronism')}}</el-button>
    </div>
    <el-table border  v-loading="loading"  :data="whiteList" style="width: 100%">
      <el-table-column :label="$t('common.date')" width="180">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.createDate }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('whiteList.platFormName')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.routesName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('whiteList.modules')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.modelName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('whiteList.domain')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.domain }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.remark')" width="180">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.remake }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.handle')">
        <template slot-scope="scope">
          <el-button size="mini" v-auth="'sys:whiteList:edit'"  @click="handleEdit(scope.row,1)">{{$t("common.edit")}}</el-button>
          <el-button size="mini" v-auth="'sys:whiteList:delete'"  type="danger" @click="handleDelete(scope.$index, scope.row)">{{$t("common.delete")}}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="showEditBox">
      <el-form :model="form">
        <el-form-item :label="$t('whiteList.gateWay')" :label-width="formLabelWidth" prop="routesId">
          <el-select   v-model="form.routesId" :placeholder="$t('whiteList.gateWay')">
            <el-option v-for="item in routesIds" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('whiteList.domain')" prop="domain" :label-width="formLabelWidth">
          <el-input v-model="form.domain" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('common.remark')" prop="remake" :label-width="formLabelWidth">
          <el-input v-model="form.remake" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showEditBox = false">{{this.$t("common.cancle")}}</el-button>
        <el-button type="primary" @click="submitData">{{this.$t("common.ok")}}</el-button>
      </div>
    </el-dialog>
    <div style="margin-top:20px;text-align:right">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10,20,50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import {
  ipWhiteList,
  getRoutesIdList,
  pullIpWhiteList,
  editIpWhiteList,
  delIpWhiteList,
  addIpWhiteList
} from "@/api/sys/ipwhite";
import { Message, MessageBox } from "element-ui";
import { localRead } from '../../utils/tools';
export default {
  data() {
    return {
      titleName: this.$t("common.edit"),
      whiteList: [],
      changeType: 0,
      gatewayBox: false,
      showEditBox: false,
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      formLabelWidth: "120px",
      routesIds: [],
      loading:false,
      form: {
        routesId: [],
        domain: "",
        remake: ""
      }
    };
  },
  mounted() {
    this.getIpwhiteList();
  },
  created() {
    this.getRoutesIds();
  },
  methods: {
    getIpwhiteList() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage
      };
      ipWhiteList(data).then(res => {
        for(let i in res.result.list){
          let language = localRead('language')
          res.result.list[i].modelName = JSON.parse(res.result.list[i].modelName)[language]
        }
        this.whiteList = res.result.list;
        this.totalSize = res.result.total;
        this.loading = false
      });
    },
    handleEdit(row, type) {
      let updateObject;
      updateObject = Object.assign({},row);
      this.changeType = type;
      if (this.changeType == 1) {
        this.form = row;
        this.titleName = this.$t("common.edit");
      } else {
         for (let key in this.form) {
          this.form[key] = "";
        }
        this.titleName = this.$t("common.addNew");
      }
      this.showEditBox = true;
    },
    handleDelete(index, row) {
      this.$confirm("是否删除白ip?", "提示", {
        confirmButtonText: this.$t("common.ok"),
        cancelButtonText: this.$t("common.cancle"),
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            delIpWhiteList(row.id).then(res => {
              if (res.code == 0) {
                this.getIpwhiteList();
              }
            });
            done();
          } else {
            done();
          }
        }
      })
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t('common.conDelete')
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('common.canDele')
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getIpwhiteList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getIpwhiteList();
    },
    synchronize() {
      pullIpWhiteList().then(res => {
        if (res.code == 0) {
          this.$alert("更新成功", "白名单", {
            confirmButtonText: this.$t("common.ok")
          });
        } else {
          this.$alert("更新失败", "白名单", {
            confirmButtonText: this.$t("common.ok")
          });
        }
      });
    },
    getRoutesIds() {
      getRoutesIdList().then(res => {
        if (res.code == 0) {
          this.routesIds = res.result;
        }
      });
    },
    submitData() {
      if (this.changeType == 1) {
        editIpWhiteList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t('common.changeSu'),
              type: "success"
            });
          }
          this.getIpwhiteList();
        });
      } else {
        addIpWhiteList(this.form).then(res => {
          if (res.code == 0) {
            Message({
              message: this.$t('common.addSu'),
              type: "success"
            });
          }
          this.getIpwhiteList();
        });
      }
         this.showEditBox = false;
    }

  }

};
</script>
<style lang="scss" scoped>
.wrapper {
  margin: 50px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
  transition: 0.2s;
  padding: 20px;
}
</style>
